(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vip-buy"] && !Shopify.designMode) return;
  try {
    (function () {
    var main = document.querySelector('.vipb > .vipb__btn');
    var sticky = document.querySelector('.vipb__sticky');
    if (main && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(main);
    }
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('[data-vip-aff]');
      if (a) {
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('vip_affiliate_click', { source: a.dataset.source, title: a.dataset.title || document.title });
          }
          if (window.gtag) gtag('event', 'affiliate_click', { source: a.dataset.source });
          if (window.fbq) fbq('trackCustom', 'AffiliateClick', { source: a.dataset.source });
          if (window.ttq) ttq.track('ClickButton', { content_name: a.dataset.title });
          if (window.snaptr) snaptr('track', 'CUSTOM_EVENT_1');
        } catch (e) {}
      }
      var c = ev.target.closest('[data-vip-copy]');
      if (c && navigator.clipboard) {
        navigator.clipboard.writeText(c.dataset.vipCopy);
        c.style.background = '#25a55f';
        setTimeout(function () { c.style.background = ''; }, 1200);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
